import { render, staticRenderFns } from "./AnimatedContent.vue?vue&type=template&id=5571b680&scoped=true"
import script from "./AnimatedContent.vue?vue&type=script&lang=js"
export * from "./AnimatedContent.vue?vue&type=script&lang=js"
import style0 from "./AnimatedContent.vue?vue&type=style&index=0&id=5571b680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5571b680",
  null
  
)

export default component.exports